/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import { useId } from 'react';
import cn from './cn';

function RadioInput({ isShow = true, checked, disabled, name, value, label, onClick }) {
    const labelId = useId();
    if (!isShow) return null;
    return (
        <label
            htmlFor={labelId}
            className={cn(`inline-flex items-center justify-start text-sm text-primary`, {
                ' text-primary-700 cursor-default  pointer-event-none': disabled
            })}
            onClick={onClick}
            role="button"
        >
            <input
                type="radio"
                id={labelId}
                name={name}
                value={value}
                onChange={onClick}
                checked={checked}
                disabled={disabled}
                className="w-4 h-4 text-primary border border-primary rounded-md"
            />
            <span className="ml-2 capitalize">{label}</span>
        </label>
    );
}

export default RadioInput;
